import { useState } from "react";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
import { Toaster, toast } from "react-hot-toast";

export default function Form({ setTrigger }) {
  const [submitted, setSubmitted] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    emailjs
      .send("service_wcgta79", "template_ekccb7o", data, "fnc0ujCNZPYr2bPnl")
      .then(() => {
        toast.success("Form Submitted Successfully!");
        setSubmitted(true);
        reset();
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        toast.error("Failed to submit form. Please try again.");
      });
  };

  return (
    <div className="xl:mt-12 lg:mt-12 mt-8 ">
      <Toaster position="top-center" reverseOrder={false} />
     <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <input
        type="text"
        {...register("fullname", { required: "Full Name is required" })}
        placeholder="Your name"
        className="xl:w-12/12 lg:w-12/12 w-full bg-white rounded-md focus:outline-none borderform"
      />
      {errors.fullname && <p className="text-red-500">{errors.fullname.message}</p>}

      <input
        type="number"
        {...register("tel", { required: "Phone Number is required" })}
        placeholder="Phone"
        className="xl:w-12/12 lg:w-12/12 w-full mt-3 bg-white rounded-md focus:outline-none borderform"
      />
      {errors.tel && <p className="text-red-500">{errors.tel.message}</p>}

      <input
        type="email"
        {...register("email", {
          required: "Email is required",
          pattern: {
            value: /\S+@\S+\.\S+/,
            message: "Invalid email format",
          },
        })}
        placeholder="Email address"
        className="xl:w-12/12 lg:w-12/12 w-full mt-3 bg-white rounded-md focus:outline-none borderform"
      />
      {errors.email && <p className="text-red-500">{errors.email.message}</p>}

      {/* Products Dropdown */}
      <select
                  {...register("product", {
                    required: "Please select a product",
                  })}
                  className="w-full rounded  px-4 mt-3 borderform"
                  
                >
                  <option value="">Select a Product</option>
                  <option value="Silos">Silos</option>
                  <option value="Storage Tanks">Storage Tanks</option>
                  <option value="Process Tanks">Process Tanks</option>
                  <option value="Mixing Tanks">Mixing Tanks</option>
                  <option value="CIP Tanks">CIP Tanks</option>
                  <option value="Incubation Tanks">Incubation Tanks</option>
                  <option value="Butter Melting Tanks">
                    Butter Melting Tanks
                  </option>
                  <option value="Jacketed Tanks">Jacketed Tanks</option>
                  <option value="Ribbon Blenders">Ribbon Blenders</option>
                  <option value="Dry Mixing Tanks">Dry Mixing Tanks</option>
                  <option value="Milk Road Tankers">Milk Road Tankers</option>
                  <option value="Insulated Tanks">Insulated Tanks</option>
                </select>
                {errors.product && (
                  <p className="text-red-500">{errors.product.message}</p>
                )}


      <select
        {...register("services", { required: "Please select a service" })}
        className="xl:w-12/12 lg:w-12/12 w-full mt-3 bg-white rounded-md focus:outline-none borderform p-2"
      >
        <option value="">Select a Service</option>
        <option value="Cheese Plants">Cheese Plants</option>
        <option value="Dairy Plants">Dairy Plants</option>
        <option value="Juice">Juice</option>
        <option value="Beverages">Beverages</option>
        <option value="Water Plants">Water Plants</option>
        <option value="Personal Care">Personal Care</option>
        <option value="Cosmetics">Cosmetics</option>
        <option value="Culinary">Culinary</option>
        <option value="Chocolate & Sweets">Chocolate & Sweets</option>
        <option value="Edible Oil">Edible Oil</option>
        <option value="Confectioneries">Confectioneries</option>
        <option value="Pharmaceuticals">Pharmaceuticals</option>
        <option value="Spices">Spices</option>
        <option value="Chemical">Chemical</option>
      </select>
      {errors.services && <p className="text-red-500">{errors.services.message}</p>}

      <textarea
        {...register("message", { required: "Message is required" })}
        placeholder="Write a message"
        rows="5"
        className="xl:w-12/12 lg:w-12/12 w-12/12 mt-3 bg-white rounded-md focus:outline-none borderform"
      ></textarea>
      {errors.message && <p className="text-red-500">{errors.message.message}</p>}

      <div className="flex xl:mt-3 mt-3 gap-4">
        <button
          type="submit"
          className="blue text-white font-semibold xl:px-6 xl:py-2 lg:px-4 lg:py-2 px-2 py-2 rounded-md shadow-md"
        >
          Send a message
        </button>

        <a
            href="/servicesbrochure.pdf"
          download
          className="blue text-white font-semibold xl:px-6 xl:py-2 lg:px-4 lg:py-2 px-2 py-2 rounded-md shadow-md"
        >
          Download Brochure
        </a>
      </div>
    </form>
    </div>
  );
}
